import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import Landing from "@/pages/Landing";
import AppShell from "@/components/AppShell";
import FeedPage from "@/pages/FeedPage";
import MarketplacePage from "@/pages/MarketplacePage";
import OfferDetailPage from "@/pages/OfferDetailPage";
import NetworkPage from "@/pages/NetworkPage";
import PipelinePage from "@/pages/PipelinePage";
import ProfilePage from "@/pages/ProfilePage";
import NotificationsPage from "@/pages/NotificationsPage";
import MatchesPage from "@/pages/MatchesPage";
import CashflowPage from "@/pages/CashflowPage";
import AffiliazionePage from "@/pages/AffiliazionePage";
import AffiliazioneRulesPage from "@/pages/AffiliazioneRulesPage";
import CashbackPage from "@/pages/CashbackPage";
import CashbackRulesPage from "@/pages/CashbackRulesPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import { useParams } from "react-router-dom";

function RefRedirect() { const { code } = useParams(); return <Navigate to={`/?register=1&ref=${encodeURIComponent(code || "")}`} replace />; }
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-neutral-400 font-mono text-sm">Caricamento…</div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  const { search } = useLocation();
  const connectReturn = search.includes("connect=");
  return (
    <Routes>
      <Route path="/r/:code" element={<RefRedirect />} />
      <Route path="/regolamento-affiliazione" element={<AffiliazioneRulesPage />} />
      <Route path="/regolamento-referral" element={<Navigate to="/regolamento-affiliazione" replace />} />
      <Route path="/come-funziona-cashback" element={<CashbackRulesPage />} />
      <Route path="/reimposta-password" element={<ResetPasswordPage />} />
      <Route path="/" element={loading ? null : user ? <Navigate to={connectReturn ? `/profilo${search}` : "/feed"} replace /> : <Landing />} />
      <Route path="/payment/success" element={<PaymentResult status="success" />} />
      <Route path="/payment/cancel" element={<PaymentResult status="cancel" />} />
      <Route element={<Protected><AppShell /></Protected>}>
        <Route path="/feed" element={<FeedPage />} />
        <Route path="/marketplace" element={<MarketplacePage />} />
        <Route path="/marketplace/:oid" element={<OfferDetailPage />} />
        <Route path="/network" element={<NetworkPage />} />
        <Route path="/pipeline" element={<PipelinePage />} />
        <Route path="/pipeline/:pid" element={<ProjectDetailPage />} />
        <Route path="/profilo" element={<ProfilePage />} />
        <Route path="/notifiche" element={<NotificationsPage />} />
        <Route path="/agganci" element={<MatchesPage />} />
        <Route path="/flusso" element={<CashflowPage />} />
        <Route path="/affiliazione" element={<AffiliazionePage />} />
        <Route path="/referral" element={<Navigate to="/affiliazione" replace />} />
        <Route path="/cashback" element={<CashbackPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <AuthProvider>
          <I18nProvider>
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
            <Toaster position="top-center" duration={2000} />
          </I18nProvider>
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}
